<template>
	<div class="info-view" :class="{ 'pointer-events-none': isCameraActive }">
		<ModalWindow
			:heading="translate('ui.info')"
			:isElevated="false"
			fullWidthContent
			:headerData="{ searchButton: true }"
		>
			<template #content>
				<Tabs :tabs="settingsTabs" :selected-index="Number(paramTab)">
					<template v-slot:tab1>
						<LeaderboardView />
					</template>
					<template v-slot:tab2>
						<StatsInfoView />
					</template>
					<template v-slot:listSlot3>
						<AppNotification
							v-if="getUnclaimedAchievements.length > 0"
							class="navigation__item__notification"
							:value="getUnclaimedAchievements.length"
							:type="StatusTypes.WARNING"
						/>
					</template>
					<template v-slot:tab3>
						<AchievementsView />
					</template>
					<template v-slot:listSlot4>
						<AppNotification
							v-if="infoNotifications > 0"
							class="navigation__item__notification"
							:value="infoNotifications"
							:type="StatusTypes.WARNING"
						/>
					</template>
					<template v-slot:tab4>
						<IncomeInfoView />
					</template>
					<template v-slot:tab5>
						<UnlockHistoryView />
					</template>
					<template v-slot:tab6>
						<NewsInfoView />
					</template>
				</Tabs>
			</template>
		</ModalWindow>
	</div>
</template>

<script lang="ts" setup>
import AppNotification from "@/components/AppNotification.vue";
import ModalWindow from "@/components/ModalWindow.vue";
import Tabs from "@/components/Tabs.vue";
import useAchievementsStore from "@/store/useAchievementsStore";
import useRuntimeStore from "@/store/useRuntimeStore";
import { StatusTypes } from "@/types/ui";
import { translate } from "@/utils/translate";
import NewsInfoView from "@/views/Info/SubTabs/NewsInfoView.vue";
import StatsInfoView from "@/views/Info/SubTabs/StatsInfoView.vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute } from "vue-router";
import AchievementsView from "./SubTabs/AchievementsView.vue";
import IncomeInfoView from "./SubTabs/IncomeInfoView.vue";
import LeaderboardView from "./SubTabs/LeaderboardView.vue";
import UnlockHistoryView from "./SubTabs/UnlockHistoryView.vue";
const route = useRoute();

const { isCameraActive, infoNotifications } = storeToRefs(useRuntimeStore());
const { getUnclaimedAchievements } = storeToRefs(useAchievementsStore());
const settingsTabs = [
	{ name: translate("ui.ranking"), icon: "ranking" },
	{ name: translate("ui.stats"), icon: "stats" },
	{ name: translate("ui.achievements"), icon: "achievements" },
	{ name: translate("ui.regular_income_all"), icon: "income" },
	{ name: translate("ui.unlock_history"), icon: "unlock" },
	{ name: translate("ui.news"), icon: "news" },
];

const paramTab = computed((): string | string[] => {
	return route.params.tab;
});
</script>

<style lang="scss" scoped>
.notification {
	position: absolute;
	right: 0.5rem;
	bottom: 0.5rem;
}
</style>
